
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPaletteDayNightIec as ObiPaletteDayNightIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-palette-day-night-iec.js';
 
 
 

 
 export const ObiPaletteDayNightIec = createComponent({
   react: React,
   tagName: 'obi-palette-day-night-iec',
   elementClass: ObiPaletteDayNightIecElement,
   events: {
     
   }
  });
 
 